// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
import { APIResource } from "../../core/resource.mjs";
import * as AgentsAPI from "./agents.mjs";
import { Agents } from "./agents.mjs";
import * as FilesAPI from "./files.mjs";
import { Files, } from "./files.mjs";
import { ArrayPage } from "../../core/pagination.mjs";
import { path } from "../../internal/utils/path.mjs";
export class Folders extends APIResource {
    constructor() {
        super(...arguments);
        this.files = new FilesAPI.Files(this._client);
        this.agents = new AgentsAPI.Agents(this._client);
    }
    /**
     * Create a new data folder.
     */
    create(body, options) {
        return this._client.post('/v1/folders/', { body, ...options });
    }
    /**
     * Get a folder by ID
     */
    retrieve(folderID, options) {
        return this._client.get(path `/v1/folders/${folderID}`, options);
    }
    /**
     * Update the name or documentation of an existing data folder.
     */
    update(folderID, body, options) {
        return this._client.patch(path `/v1/folders/${folderID}`, { body, ...options });
    }
    /**
     * List all data folders created by a user.
     */
    list(query = {}, options) {
        return this._client.getAPIList('/v1/folders/', (ArrayPage), { query, ...options });
    }
    /**
     * Delete a data folder.
     */
    delete(folderID, options) {
        return this._client.delete(path `/v1/folders/${folderID}`, options);
    }
}
Folders.Files = Files;
Folders.Agents = Agents;
//# sourceMappingURL=folders.mjs.map